import { Provider } from '@angular/core';
import {
  PublicRestService,
  RestArchivaceService,
  RestCertifikatService,
  RestCiselnikyService,
  RestExportService,
  RestNaseptatCiselnikService,
  RestObjektyRppService,
  RestOpravneniService,
  RestOvereniCertifikatService,
  RestOvereniOpravneniService,
  RestReklamaceImplService,
  RestReklamaceService,
  RestSablonaService,
  RestStatistikyService,
  RestUzivatelService,
} from '@generated/be';

/**
 * Generované REST služby BE, které aplikace používá, jako providery pro root aplikace.
 *
 * Generátor běží s `providedIn=none` (skript `generate-api-be` v package.json), služby jsou proto jen
 * `@Injectable()` a musí je někdo poskytnout. Jsou to bezstavové obálky nad `HttpClient` (`BASE_PATH`
 * je jen v rootu), takže stačí jedna instance pro celou aplikaci – routy ani komponenty je nevyjmenovávají.
 *
 * Záměrně ne celé pole `APIS`: obsahuje i služby, které FE nevolá (debug, interní testy, joby a procesy BE),
 * a ty by zbytečně zvětšily hlavní balíček. Novou službu z `@generated/be` stačí doplnit sem.
 * Soubor je mimo `generated/be-service`, protože se ten adresář při generování maže.
 */
export function provideRezaRestServices(): Provider[] {
  return [
    PublicRestService,
    RestArchivaceService,
    RestCertifikatService,
    RestCiselnikyService,
    RestExportService,
    RestNaseptatCiselnikService,
    RestObjektyRppService,
    RestOpravneniService,
    RestOvereniCertifikatService,
    RestOvereniOpravneniService,
    RestReklamaceImplService,
    RestReklamaceService,
    RestSablonaService,
    RestStatistikyService,
    RestUzivatelService,
  ];
}
